import React from "react";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import Icon from "../components/Icon";
import "../styles/contact.css";

function Contact() {
  return (
    <>
      <PageHero
        eyebrow="Request a demo"
        title="See MPeoples HRMS on your own attendance data"
        subtitle="Tell us a little about your organization and we'll walk you through attendance, leave, payroll, and the Admin Dashboard."
      />

      <section className="section contact-section">
        <div className="container contact-grid">
          <ul className="cta-points">
            <li>
              <Icon name="check" size={14} /> Selfie + location-verified check-in and check-out
            </li>
            <li>
              <Icon name="check" size={14} /> Automated late-minute payroll deductions
            </li>
            <li>
              <Icon name="check" size={14} /> A full HR console for your team
            </li>
          </ul>

          <ContactForm />
        </div>
      </section>
    </>
  );
}

export default Contact;
